// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__25jJZ","title":"Images90_title__3iy1Q","images":"Images90_images__h32T5"};